import { buildPrimaryFetchInit } from "./fetchInit";
import { resolvePrimaryEnvironmentHttpUrl } from "./target";

async function readLogoutErrorMessage(
  response: Response,
  fallbackMessage: string,
): Promise<string> {
  const text = await response.text();
  return text || fallbackMessage;
}

export async function logoutPrimaryHttpSession(): Promise<void> {
  const endpointUrl = resolvePrimaryEnvironmentHttpUrl("/api/auth/logout");
  const response = await fetch(
    endpointUrl,
    buildPrimaryFetchInit({ credentials: "include", method: "POST" }),
  );

  if (!response.ok) {
    throw new Error(
      await readLogoutErrorMessage(
        response,
        `Failed to logout authenticated session (${response.status}).`,
      ),
    );
  }
}
